package com.fireavert.properties.delete_property_dialog

import com.fireavert.properties.logic.delete_property.DeleteProperty

class DeletePropertyDialogController(private val interactor: DeleteProperty) {
    fun clickedCancel() = interactor.cancel()
    fun clickedDeleteProperty(propertyId: Int) = interactor.deleteProperty(propertyId)
}